import React, { FC } from 'react'
import classNames from 'classnames'

import { getStyledElementProps } from '@/utils'
import { InputCaption, InputLabel } from '@/atoms'
import { BaseFieldProps } from '@/types'

import styles from './base-field.module.scss'

export const BaseField: FC<BaseFieldProps> = ({
  error,
  label,
  caption,
  children,
  disabled = false,
  fullWidth = false,
  containerProps = {},
  labelProps = {},
  captionProps = {},
}) => {
  const styledContainerProps = getStyledElementProps(
    containerProps,
    classNames(styles['container'], {
      'pui-sizing-full-width': fullWidth,
      'not-allowed': disabled,
    })
  )

  const styledLabelProps = getStyledElementProps(labelProps, styles['label'])
  return (
    <div {...styledContainerProps}>
      {label && <InputLabel {...styledLabelProps}>{label}</InputLabel>}
      {children}
      {caption && (
        <InputCaption
          error={error}
          typographyColor={'gray-3'}
          {...captionProps}
        >
          {caption}
        </InputCaption>
      )}
    </div>
  )
}
